import ActivityType from '../Pages/ActivityType'
import Resources from '../Pages/Resources';
import Expense from '../Pages/Expense';
import Home from '../Pages/Home'
import Employee from '../Pages/Employee'
import ActivitiesList from '../Pages/ActitiviesList/'
import Operator from '../Pages/Operator';
import Password from '../Pages/Password';
import Attendances from '../Pages/Company/TimeClock/Attendances/Employees';
import TimeClock from '../Pages/Company/TimeClock'
import EmployeeEmail from '../Pages/EmployeeEmail'

export const routes = [
  { path: '/home', component: Home, icon: 'home', label: 'Home' },
  { path: '/activities/list/:employeeId', invisible: true, component: ActivitiesList, },
  { path: '/type/activity', component: ActivityType, icon: 'take-action', label: 'Tipos de Atividade' },
  { path: '/type/resources', component: Resources, icon: 'drive-time', label: 'Tipos de Recurso' },
  { path: '/type/expense', component: Expense, icon: 'dollar', label: 'Tipos de Despesa' },
  { path: '/employee', component: Employee, icon: 'new-person', label: 'Convidar Funcionários', adminOnly: true },
  { path: '/operator', component: Operator, icon: 'new-person', label: 'Convidar Operador', adminOnly: true },
  { path: '/accounts/password', component: Password, icon: 'new-person', label: 'Convidar Operador', invisible: true },
  { path: '/timeclock/attendances', component: Attendances, icon: 'th-derived', label: 'Consulta Ocorrêncida Ponto', adminOnly: true },
  { path: '/timeclock', component: TimeClock, icon: 'time', label: 'Configuração de Ponto', adminOnly: true },
  { path: '/employeeemail', component: EmployeeEmail, icon: 'new-person', label: 'Configurar Envio Relatório', adminOnly: true },
]

export function getUserRoutes(role) {
  if (role === "operator") return routes.filter(route => !route.adminOnly)
  else if (role === "manager") return routes
  else return []
}